<template>
  <div class="container">
    <div class="about">
      <p>Mini Weather App – це веб-додаток, який дозволяє користувачам отримувати інформацію про погоду в певному місці. Він забезпечує зручний інтерфейс для доступу до поточних і прогнозованих даних про погоду для будь-якого місця, просто ввівши назву міста. Додаток розроблено таким чином, щоб бути простим і легким у використанні, що робить його ідеальним для людей, які хочуть отримувати швидкі оновлення погоди без потреби в більш складній і багатофункціональній програмі погоди.</p>
      <p>Додаток використовує API для отримання даних про погоду та відображення їх користувачеві у візуально привабливому вигляді. Він містить основну інформацію про погоду, таку як температура.</p>
      <p>Програма Mini Weather створена за допомогою сучасних веб-технологій, таких як Vue.js, HTML, CSS і JavaScript, що робить її легкою та швидкою програмою.</p>
      <p>Загалом, Mini Weather App є чудовим інструментом для тих, хто хоче швидко та легко отримати доступ до інформації про погоду. Його простий та інтуїтивно зрозумілий інтерфейс робить його ідеальним вибором для тих, хто хоче бути в курсі погоди без необхідності переглядати безліч функцій і даних.</p>
      <p>Незалежно від того, чи плануєте ви подорож чи просто хочете дізнатися прогноз на день, додаток Mini Weather допоможе вам.</p>
    </div>
  </div>
</template>
  
  <script>
  import {defineComponent} from 'vue'
  
  export default defineComponent({
    setup(){
  
      return{}
    }
  })
  </script>
  
  <style scoped>

  .about {
    background-image: url('../assets/about.png');
    background-size: cover;
    background-position: bottom;

    height: 100vh;
    padding-top: 30px;
  }

  .about p {
    padding: 10px 25px;
  }
  
  </style>